import React, { useEffect } from "react";
import MiniDrawer from "../../Component/newNavBarCM/newNavBar";
import ExpertRecordsDetail from "../../Component/ExpertRecordsDetail/ExpertRecordsDetail";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../NewComponent/LayoutCM/Layout";

//Delete later

import { getExpertrecords, getKeyTag, getRerouteUser } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action/index";

export default function ExpertRecordsPageDetails() {
  const state = useSelector((state) => state.expertRecord);
  const navigate = useNavigate();
  const { questionUuid, userType } = useParams();
  const dispatch = useDispatch();
  const {
    cmrClickedData,
    getSeekerAttachmentsForExpertRecords,
    cmrIsBackFromEmailLink,
  } = bindActionCreators(Actions, dispatch);

  useEffect(() => {
    if (state.clickedData) return;

    getExpertrecords({
      questionUuidStr: atob(questionUuid),
    }).then((res) => {
      if (res === undefined) {
        navigate("/cmHome/expertResponses/");
        return;
      }
      const data = res.data.data[0];
      if (!data) {
        navigate("/cmHome/expertResponses/");
        return;
      }

      cmrClickedData(data);
      cmrIsBackFromEmailLink(true);
      getKeyTag([data.questionUuid]);
      if (data.fileNames) {
        getSeekerAttachmentsForExpertRecords(data.fileNames);
      }
    });
  });

  return (
    <Layout>
      {state.clickedData !== null && <ExpertRecordsDetail />}
      <br />
      <br />
    </Layout>
  );
}
